import { useCallback, useMemo } from "react";
import type { BellTarget, LocalActionId, LocalBell, LocalBellRow } from "@heraion/ui";

import { useProfileNameBell } from "./profileNameBell";

// The web's rows of the bell (#178). Today one: the name that was not saved.
// The phone's other rows (Health Connect, queue, drafts) have no web twin.
// Its one action, Open, goes to the row's target.

export function useWebLocalBell(
  owner: string,
  openTarget: (target: BellTarget) => boolean,
): LocalBell {
  const profileName = useProfileNameBell(owner);
  const rows = useMemo<readonly LocalBellRow[]>(
    () => (profileName ? [profileName] : []),
    [profileName],
  );
  const run = useCallback(
    async (row: LocalBellRow, action: LocalActionId): Promise<boolean> =>
      action === "open" && row.target !== null ? openTarget(row.target) : false,
    [openTarget],
  );
  return useMemo(() => ({ rows, run, busyId: null, error: null }), [rows, run]);
}
